import { forwardRef } from 'react';

import { IconProps } from './icons.types';

import { SvgStyled } from './icons.styles';

export const LocationIcon = forwardRef<SVGSVGElement, IconProps>(function LocationIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.72086 11.0433C4.38655 10.276 1.9411 8.51995 1.4838 5.94808C1.29247 4.87199 1.50204 3.58507 2.20508 2.59116C2.87969 1.63745 4.05701 0.881174 6 0.881174C7.94299 0.881174 9.1203 1.63745 9.79491 2.59116C10.498 3.58507 10.7075 4.87199 10.5162 5.94809C10.0589 8.51996 7.61347 10.2761 6.27915 11.0433C6.10398 11.144 5.89603 11.144 5.72086 11.0433ZM5.2503 11.7995C3.89116 11.018 1.11139 9.08376 0.58024 6.09654C0.128571 3.55631 1.53683 0 6 0C10.4632 0 11.8714 3.55631 11.4198 6.09654C10.8886 9.08377 8.10885 11.018 6.74971 11.7995C6.28477 12.0668 5.71524 12.0668 5.2503 11.7995Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 6.23145C5.61199 6.23145 5.08333 5.83817 5.08333 5.08045C5.08333 4.32272 5.61199 3.92944 6 3.92944C6.38801 3.92944 6.91667 4.32272 6.91667 5.08045C6.91667 5.83817 6.38801 6.23145 6 6.23145ZM6 7.11263C4.98748 7.11263 4.16667 6.20279 4.16667 5.08045C4.16667 3.95811 4.98748 3.04827 6 3.04827C7.01252 3.04827 7.83333 3.95811 7.83333 5.08045C7.83333 6.20279 7.01252 7.11263 6 7.11263Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
